(function($) {

	$.fn.attachmentsform = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.attachmentsform.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            addMultiFileUploader($this.find('input:file'));

            $this.on('click', ':submit', function(){
                submitAttachments($this, eOpts);
                return false;
            });

            $this.find('.add-attachment-button').click(function(){
                var $button = $(this);
                showAttachmentDialog($button, $button.parents('.attachments-row').find('li.file-template'));
            });

            $this.find('.edit-attachment-button').click(function(){
                var $button = $(this);
                showAttachmentDialog($button, $button.parents('li'));
            });

            $this.find('.remove-attachment-button').click(function(){
                var $button = $(this);
                toggleRemoveAttachment($button, $button.parents('li'));
            });

        });
	};
	//
	// plugin defaults
	//
	$.fn.attachmentsform.defaults = {
        'bar-image': staticImageUrl('/common/progressbg_orange.gif'),
        'box-image': staticImageUrl('/common/progressbar.gif'),
        'attachment-progress-url': '/fpm/attachments/progress'
	};
    //
    // Private functions
    //
    function submitAttachments($this, eOpts) {
//        $this.find('li.file-template :input').prop('disabled', true); // Disable all template inputs
        // For some reason the above selector does not work in IE8, but splitting it into two queries does work. FPM-2494
        $this.find('li.file-template').find(':input').prop('disabled', true); // Disable all template inputs

        var $enabledSubmits = $this.find(".ui-button:submit:enabled").button('disable');

        var $fileInputs = $this.find('input:file');
        var fileCount = $fileInputs.size();
        var errorCount = 0;
        var submitFormWhenAllUploaded = function()
        {
            if (fileCount == 0) {
                try {
                    $enabledSubmits.filter('.ui-button').button('enable');
                } catch (e) {
                    // Using try block because for unknown reason this sometimes fails with:
                    // "Uncaught Error: cannot call methods on button prior to initialization; attempted to call method 'enable'"
                }
                if (errorCount == 0) {
                    $this.find('input:file').prop('disabled', true); // Attachments have already been uploaded so disable file inputs
                    $this.submit();
                }
            }
        };
        $fileInputs.each(function()
        {
            var $fileInput = $(this);
            var fileInputId = $fileInput.attr('id');
            if($fileInput.val() && $fileInput.parents('li.file-template').size() == 0)
            {
                // actionUrl may have navigation redirect parameter specified so remove before use in ajax file upload
                var actionUrl = $this.attr("action");
                if (actionUrl.indexOf('?') > 0)
                {
                    actionUrl = actionUrl.substring(0,actionUrl.indexOf('?'));
                }
                var uploadInfoHandle;
                var successHandler = function() {
                    fileCount--;
                    submitFormWhenAllUploaded();
                };
                var errorHandler = function() {
                    //File upload fails, stop the upload process and warn user
                    fileCount--;
                    errorCount++;

                    var $li = $this.find('#' + fileInputId).closest('li');
                    $li.append($.formbuilder('error-message', {text: "Attachment upload failed. Please remove this attachment, add it again as a new attachment and then try to save the page again."}));
                    //Enable the template button
                    $this.find('li.file-template').find(':input').prop('disabled', false);
                    //Stop the progress bar as well
                    if (uploadInfoHandle) {
                        clearInterval(uploadInfoHandle);
                    }
                    var $progressBar = $('#' + fileInputId + '-upload-bar');
                    if ($progressBar.length) {
                        $progressBar.remove();
                    }
                    submitFormWhenAllUploaded();
                };
                $.ajaxFileUpload({
                    //FPM-9842 add "attachment" prefix in the url, this is used in assessment standard and action point narrative attachment upload
                    url: actionUrl + "/attachment?fileIdentifier=" + fileInputId,
                    secureuri:false,
                    formId:$this.attr('id'),
                    fileElementId:fileInputId,
                    dataType: 'json',
                    success: function (data)
                    {
                        if (data.success) {
                            successHandler();
                        } else {
                            errorHandler();
                        }
                    },
                    error: errorHandler
                });
                uploadInfoHandle = showUploadProgress(fileInputId, eOpts);
            }
            else
            {
                fileCount--;
                $fileInput.prop('disabled', true);
                submitFormWhenAllUploaded();
            }
        });
        return false;
    }
    function showUploadProgress(fileInputId, eOpts)
    {
        var uploadInfoHandle = {};
        var uploadInfo = function getUploadInfo()
        {
            var $progressBar = $('#' + fileInputId + '-upload-bar');
            $progressBar.show();
            var barConfig = {barImage: eOpts['bar-image'], boxImage: eOpts['box-image']};
            $progressBar.progressBar(barConfig);
            $.ajax({
                       url: eOpts['attachment-progress-url'] + '?fileIdentifier=' + fileInputId,
                       type: 'GET',
                       cache: false,
                       dataType: 'json',
                       async: false,
                       success: function(data)
                       {
                           if(data.result == 'UPLOADING')
                           {
                               var progressMap = data.progressMap;
                               var progressVal = (progressMap.bytesRead / progressMap.contentLength) * 100;
                               $progressBar.progressBar(progressVal, barConfig);
                           }
                           else if(data.result == 'DONE')
                           {
                               $progressBar.progressBar(100, barConfig);
                               clearInterval(uploadInfoHandle[fileInputId]);
                           }
                           else if(data.result == 'MAX_SIZE_EXCEEDS')
                           {
                               clearInterval(uploadInfoHandle[fileInputId]);
                               $progressBar.hide();
                               alert(translate('The file exceeds the maximum supported file size'));
                           }
                          else
                          {
                              clearInterval(uploadInfoHandle[fileInputId]);
                              var details = data.details ? '\r\n Details:' + data.details : '';
                              var result = data.result ? '\r\n Result:' + data.result : '';
                              if (console && console.log) {
                                  console.log(translate('An unexpected error occurred while checking the status of the file upload.') + ' ' +
                                      translate('The file may have uploaded successfully, but this message should be reported to the development team.') + '\r\n' +
                                      details + '\r\n' +
                                      result);
                              }
                          }
                       },
                       error: function(jqXHR, textStatus, errorThrown)
                       {
                           clearInterval(uploadInfoHandle[fileInputId]);
                           var details = errorThrown ? '\r\n' + translate('Error') + ': ' + errorThrown : '';
                           if (console && console.log) {
                               console.log(translate('An unexpected error occurred while checking the status of the file upload.') + ' ' +
                                   translate('The file may have uploaded successfully, but this message should be reported to the development team.') + '\r\n' +
                                   translate('Time') + ': ' + new Date() + '\r\n' +
                                   translate('Status') + ': ' + textStatus +
                                   details);
                           }
                       }
                   });
        };
        uploadInfoHandle[fileInputId] = setInterval(uploadInfo, 500);
        return uploadInfoHandle[fileInputId];
    }

    function addMultiFileUploader($fileInput) {
        $fileInput.multiFileUploader({
            appendUploadQueue: function(fileInput)
            {
                appendAttachment(fileInput);
            },
            detachFromUploadQueue: function(bulkUploaderRemove){
                var $li = $(bulkUploaderRemove).closest('li');
                $li.remove();
                if($li.parent().children().size()==0) {
                    var $questionAttachments = fileInput.closest('.attachments-row').find('.attachments');
                    $questionAttachments.hide();
                }
            },
            unsupportedFileType:function() {
                alert(translate('The file type you are attempting to upload is not supported'));
            }
        });
    }

    function clone($element) {
        if($.browser.msie)
        {
            // For some reason the JQuery clone method doesn't work on IE. It successfully creates a
            // detached clone but it doesn't return the root element, it returns one of it's children.
            return $($element[0].cloneNode(true));
        }
        else
        {
            return $element.clone();
        }
    }

    function appendAttachment(fileInput) {
        var $newFileInput = $(fileInput);
        var $questionAttachmentsRow = $newFileInput.closest('.attachments-row');
        var $questionAttachments = $questionAttachmentsRow.find('.attachments');
        var $ul = $questionAttachmentsRow.find('ul');
        var $template = $newFileInput.parents('li');
        var $fileInput = $template.find('input:file').first();
        var $li = clone($template);
        $li.removeClass('file-template');
        $li.find('.form-input-file input:file').remove();
        $li.find('.form-input-file').append($fileInput);
        var index = $ul.children(':has(:input[name*=newAttachments])').not($template).size();
        $li.find('input[name]').each(function(){
            $(this).attr('name', $(this).attr('name').replace('INDEX', index));
        });
        $li.find('input[id]').each(function(){
            $(this).attr('id', $(this).attr('id').replace('INDEX', index));
        });
        var removeInput = $li.find('input.multi-file-uploader-remove');
        removeInput.val($fileInput.val());
        var removeLabel = $li.find('.remove-checkbox label');
        removeLabel.attr('for', removeLabel.attr('for').replace('INDEX', index));
        $li.find('input').prop('disabled', false);
        if (!$li.find('input.file-url').val()) {
            var $progressBar = $li.find('.progressbar');
            $progressBar.attr('id', $progressBar.attr('id').replace('FILEINPUTID', $fileInput.attr('id')));
        }
        $li.find('.edit-attachment-button').click(function(){
            var $button = $(this);
            showAttachmentDialog($button, $li);
        });

        $li.find('.remove-attachment-button').click(function(){
            var $button = $(this);
            toggleRemoveAttachment($button, $li);
        });
        $template.find('input[name],textarea').val('');
        $li.insertBefore($template).show();
        $questionAttachments.removeClass('attachments-empty').show();
    }

    function showAttachmentDialog($button, $li) {
        var $dialog = $('<div></div>');
        $dialog.builddialog('textform', {
            title: $button.text(),
            formClass: 'wide-fields',
            dialogOptions: {
                close: function(){
                    var $fileInput = $dialog.find('input:file');
                    if($fileInput.size() > 0) {
                        cancelAttachmentDialog($dialog, $li);
                    }
                }
            }
        });
        $dialog.builddialog('message', {text: 'You may select a file or enter a URL'});
        var helper = $('<a></a>').attr('href', '/fpm/documents/types').addClass('message icon dialog-link ui-state-highlight');
        var contextualHelper = $('<image></image>').attr('src', staticImageUrl('/common/contextual-help.png')).attr('alt', '-?-').attr('border', '0').addClass('contextual-help');
        helper.append(contextualHelper);
        $dialog.builddialog('file', {name: 'file', label: "File", required: false, inputClass: 'one-field', helper : helper});
        var $fileInput = $li.find('.form-input-file input:file');
        $dialog.find('input:file').replaceWith($fileInput);
        $dialog.builddialog('text', {name: 'url', label: "URL", required: false, inputClass: 'one-field', value: $li.find('input.file-url').val()});
        $dialog.builddialog('text', {name: 'name', label: "Name", required: true, value: $li.find('input.file-name').val(), inputClass: 'filename-field {\'target-selector\': \'#'+$fileInput.attr('id')+'\'}'});
        $dialog.builddialog('textarea', {name: 'description', label: "Description", required: false, value: $li.find('input.file-description').val()});
        var buttonText =  $li.hasClass('file-template') ? 'Add Attachment' : 'Save Attachment';
        $dialog.builddialog('button', {
            'text': buttonText,
            'click': function(){
                saveAttachmentDialog($dialog, $li);
            }
        });
        $dialog.builddialog('show');
    }

    function cancelAttachmentDialog($dialog, $li) {
        var $fileInput = $dialog.find('input:file');
        $fileInput.val();
        // user has cancelled dialog so put file input back
        $li.find('.form-input-file').append($fileInput);
    }

    function saveAttachmentDialog($dialog, $li) {

        if (validateAttachment($dialog)) {
            var $fileInput = $dialog.find('input:file');
            $li.find('.form-input-file').append($fileInput);

            var url = $dialog.find('input[name=url]').val();
            var name = $dialog.find('input[name=name]').val();
            var description = $dialog.find('textarea[name=description]').val();

            $li.find('input.file-url').val(url);
            $li.find('input.file-name').val(name);

            // if the user has selected a new file then remove link to old file, file details and icon
            if ($fileInput.val() && $li.find('a.file-name').size() > 0) {
                var $template = $li.siblings('.file-template');
                $li.find('a.file-name').replaceWith(clone($template.find('span.file-name')));
                $li.find('span.file-details').replaceWith(clone($template.find('span.file-details')));
                $li.removeClass().addClass('file');
            }
            $li.find('span.file-name,a.file-name').text(name);

            $li.find('input.file-description').val(description);
            if (description) {
                var $description = $li.find('p.file-description');
                if ($description.size() == 0) {
                    $description = $('<p class="file-description"></p>');
                    $li.append($description);
                }
                $description.text(description);
            }
            else {
                $li.find('p.file-description').remove();
            }

            var $originalFileNameInput = $li.find('input.original-file-name');
            var fileName = $fileInput.val();
            // some browsers may give a full file path so substring just the file name.
            fileName = fileName.substring(fileName.lastIndexOf('\\') + 1); // Windows paths
            fileName = fileName.substring(fileName.lastIndexOf('/') + 1); // Unix paths
            $originalFileNameInput.val(fileName);

            if ($li.hasClass('file-template')) {
                $fileInput.trigger('change-file');
            }

            $dialog.builddialog('close');
        }
    }

    function validateAttachment($dialog) {
        var valid = true;
        var $fileInput = $dialog.find('input:file');
        var $urlInput = $dialog.find('input[name=url]');
        var $nameInput = $dialog.find('input[name=name]');
        $dialog.find('.message.ui-state-error').remove();
        $dialog.find('.error').removeClass('error');
        if(!$fileInput.val() && !$urlInput.val()) {
            valid = false;
            $fileInput.addClass('error');
            $urlInput.addClass('error');
            $urlInput.parents('.form-row').append($.formbuilder('error-message', {text: 'ONE_TYPE_REQUIRED'}));
        }
        if(!$nameInput.val()) {
            valid = false;
            $nameInput.addClass('error');
            $nameInput.parents('.form-row').append($.formbuilder('error-message', {text: 'REQUIRED_FIELD'}));
        }
        return valid;
    }

    function toggleRemoveAttachment($button, $li) {
        var $checkbox = $li.find('.remove-checkbox input:checkbox');
        $checkbox.trigger('click');
        $li.hide();
    }

})(jQuery);